/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Fulfillments_To_BookInputs */

const en_queue_fulfillments_to_book = /** @type {(inputs: Queue_Fulfillments_To_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DDP shipments to book`)
};

/**
* | output |
* | --- |
* | "DDP shipments to book" |
*
* @param {Queue_Fulfillments_To_BookInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_fulfillments_to_book = /** @type {((inputs?: Queue_Fulfillments_To_BookInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Fulfillments_To_BookInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_fulfillments_to_book(inputs)
});